import { ReactElement } from 'react'
import Layout from '../../components/layout'
import UserDetails from '../../components/Users/details'

const UserDetailsPage = (): ReactElement => {
  return (
    <Layout >
      <UserDetails />
    </Layout>
  )
}

export default UserDetailsPage
